function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from "react";
import Input from "@hig/input";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Checkmark16 } from "@hig/icons";
import MaskedInput from "react-text-mask";
import DataList from "./DataList/DataList";
import CloseIcon from "./CloseIcon";

const TextInput = ({
  state,
  dispatch,
  className,
  placeholder,
  handleChange,
  handleSubmit,
  datalist,
  value,
  focusIn,
  handleValidation,
  handleClose,
  // eslint-disable-next-line no-unused-vars
  isError,
  isLoading,
  id,
  // adding for automation locators.
  autoComplete,
  showClose,
  showGreenTick,
  enableMask,
  mask
}) => {
  const [isFocus, setIsFocus] = useState(false); // manage internal state of input value.
  // const [curValue, setInputValue] = useState(value);

  const {
    langStrings,
    serialNumberAndProductName
  } = state;
  let updatedSerial = serialNumberAndProductName;

  if (updatedSerial !== 'undefined' && updatedSerial !== '' && typeof updatedSerial !== 'object') {
    /**
     * NOTE: When user already chose serial number and product and now 
     * start removing char one by one from behind then below would fix the issue in search.
    */
    updatedSerial = updatedSerial.replace('     ', ' ');
    /**
     * NOTE: When user not chose serial number and product yet and now 
     * he is start typing, serial number -> then product list should show best match on top.
    */

    updatedSerial = updatedSerial.replace(' ', '     '); // Below function will improve search functionality with serial number and prod name search.
  } // Below function will improve search functionality with serial number and prod name search.


  const datalistFiltered = datalist && datalist.filter(item => {
    return item.includes(updatedSerial);
  });
  const inputRef = useRef();
  useEffect(() => {
    if (focusIn) {
      inputRef.current.focus();
    }
  }, [focusIn]); // eslint-disable-next-line no-unused-vars

  const handleFocusChange = e => {
    setIsFocus(true);
  };

  const handleBlurChange = e => {
    setIsFocus(false); // if Application wants to do separate call to handle validation on focus out.

    if (typeof handleValidation === 'function') {
      handleValidation(e.target.value);
    } else {
      handleChange(e);
    }
  };

  const handleOnChange = e => {
    // setInputValue(e.target.value);
    // const cleanValue = e.target.value.replace(/[^\d|-]/g, '');
    // if(isFocus && cleanValue.length === 12 && datalist.length === 0) {
    //   setIsFocus(false);
    // }
    handleChange(e);
  };

  const onKeyDown = e => {
    if (e.key === 'Enter') {
      setIsFocus(false);

      if (typeof handleValidation === 'function') {
        handleValidation(e.target.value);
      } else {
        handleChange(e);
      }
    }
  };

  const handleFocus = ele => {
    if (!isFocus) setIsFocus(true);
    document.querySelector('#serial-number-input').addEventListener('click', e => {
      if (value) {
        const cleanValue = value.replace(/[^\d|-]/g, '');
        e.target.setSelectionRange(cleanValue.length, cleanValue.length);
      } else {
        e.target.setSelectionRange(0, 0);
      }
    });
    ele.preventDefault();
  };

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      handleSubmit();
      e.preventDefault();
    }
  }, enableMask ? /*#__PURE__*/React.createElement(MaskedInput, {
    mask: mask,
    showMask: true,
    guide: true,
    keepCharPositions: true,
    onChange: handleOnChange,
    onBlur: e => handleBlurChange(e),
    id: "serial-number-input",
    onFocus: handleFocus,
    render: (ref, props) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, _extends({
      className: className,
      variant: "box",
      placeholder: placeholder,
      onKeyDown: onKeyDown,
      value: value,
      inputRef: ref,
      id: id,
      autoComplete: autoComplete,
      onMouseEnter: e => e.preventDefault(e),
      onMouseLeave: e => e.preventDefault(e)
    }, props)), datalist && isFocus && /*#__PURE__*/React.createElement(DataList, {
      langStrings: langStrings,
      serialNumberAndProductName: serialNumberAndProductName,
      dispatch: dispatch,
      datalist: datalistFiltered
    }))
  }) : /*#__PURE__*/React.createElement(Input, {
    className: className,
    variant: "box",
    placeholder: placeholder,
    onChange: handleOnChange,
    onKeyDown: onKeyDown,
    value: value,
    onFocus: e => handleFocusChange(e),
    onBlur: e => handleBlurChange(e),
    inputRef: inputRef,
    id: id,
    autoComplete: autoComplete
  }), datalist && isFocus && /*#__PURE__*/React.createElement(DataList, {
    langStrings: langStrings,
    serialNumberAndProductName: serialNumberAndProductName,
    dispatch: dispatch,
    datalist: datalistFiltered
  }), showClose && /*#__PURE__*/React.createElement(CloseIconkDiv, null, /*#__PURE__*/React.createElement(CloseIcon, {
    onClick: handleClose
  })), isLoading && /*#__PURE__*/React.createElement(LoadingSpinner, null), showGreenTick && /*#__PURE__*/React.createElement(Checkmark16, {
    color: "green",
    style: {
      marginLeft: 'calc(100% - 30px)',
      transform: 'translateY(-40px)',
      height: '20px'
    }
  }));
};

TextInput.propTypes = {
  autoComplete: PropTypes.bool,
  state: PropTypes.object,
  className: PropTypes.string,
  datalist: PropTypes.array,
  dispatch: PropTypes.func,
  enableMask: PropTypes.bool,
  focusIn: PropTypes.bool,
  handleValidation: PropTypes.func,
  handleChange: PropTypes.func,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  id: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  inputRef: PropTypes.object,
  mask: PropTypes.object,
  placeholder: PropTypes.string,
  showClose: PropTypes.bool,
  showGreenTick: PropTypes.bool,
  value: PropTypes.string
};
const CloseIconkDiv = styled.div`
  margin-left: calc(100% - 30px);
  top: -38px;
  width: 20px;
  margin-right:10px;
  height: 18px;
  position: relative;
`;
const LoadingSpinner = styled.div`
  top: -42px;
  width: 28px;
  height: 28px;
  margin-left: calc(100% - 37px);
  margin-right: 10px;
  background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdmctbG9hZGVyLXJpbmctcGFydGlhbCIgdmlld0JveD0iMCAwIDc5LjggNzkuOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48c3R5bGU+LmNlc3Qwe29wYWNpdHk6LjE1O2VuYWJsZS1iYWNrZ3JvdW5kOm5ld30uY2VzdDAsLmNlc3Qxe2ZpbGw6IzY2Nn08L3N0eWxlPgogICAgPHBhdGggaWQ9ImNlU3VidHJhY3Rpb25fMl8xXyIgY2xhc3M9ImNlc3QwIiBkPSJNMzkuOSA3OS44QzE3LjggNzkuOCAwIDYxLjkgMCAzOS45IDAgMTcuOCAxNy45IDAgMzkuOSAwczM5LjkgMTcuOSAzOS45IDM5LjljMCAxNi05LjYgMzAuNS0yNC40IDM2LjctNC45IDIuMS0xMC4yIDMuMi0xNS41IDMuMnptMC03NkMyMCAzLjggNCAxOS45IDQgMzkuN2MwIDE5LjggMTYuMSAzNS45IDM1LjkgMzUuOHMzNS45LTE2LjEgMzUuOC0zNS45YzAtMTQuNC04LjYtMjcuNC0yMS45LTMzLTQuNC0xLjgtOS4xLTIuOC0xMy45LTIuOHoiLz4KICAgIDxwYXRoIGlkPSJjZVN1YnRyYWN0aW9uXzNfMV8iIGNsYXNzPSJjZXN0MSIgZD0iTTc5LjkgMzkuOGgtNGMwLTE5LjktMTYuMS0zNi0zNS45LTM2aC0uMXYtNGMyMiAwIDM5LjkgMTcuOSA0MCA0MHoiLz4KPC9zdmc+);
  position: relative;
  animation: mymove 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  @keyframes mymove {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }  
`;
export default styled(TextInput)`
  position:relative;
  margin-bottom: 10px;
  overflow: hidden;
  border-bottom-color: rgba(128,128,128,0.2);

  > input {
    font-weight: 400;
    ${({
  isError
}) => isError && `
      border: 1px solid #ec4a41;
      box-shadow: none;
    `}

    :focus {
      ${({
  isError
}) => isError ? `
        border: 1px solid #ec4a41;
        box-shadow: none;
        ` : `
          border: 1px solid #0696d7;
          box-shadow: 0 0 5px #0696d7;
        `}
    ::placeholder {
      font-style: italic;
    }
  > div {
    height: 0px;
  }
`;